import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, ordersPickingListActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, ordersPickingListActions);

export default slice.reducer;
